import { useEffect, useLayoutEffect } from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import bingOlyImg from '@/assets/images/Olybet/bing-oly.svg';
import welcomeImg from '@/assets/images/Olybet/welcome_img.png';

import { useJWT } from '@/hooks/useJWT.hook';
import { useSettings } from '@/hooks/useSettings.hook';

import { RoutesEnum } from '@/enums/routes.enum';

import { tKeys } from '@/i18n/resourses';

export const WelcomeModal = () => {
  const { pathname } = useLocation();
  const { isMobile } = useSettings();

  const {
    isOpen: isSplashScreenOpen,
    onOpen: onSplashScreenOpen,
    onClose: onSplashScreenClose,
  } = useDisclosure();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { t } = useTranslation();

  const { jwt } = useJWT();

  const isUnsubscribe = pathname === RoutesEnum.unsubscribe;

  useLayoutEffect(() => {
    onSplashScreenOpen();
  }, [onSplashScreenOpen]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onSplashScreenClose();
    }, 1500);

    return () => clearTimeout(timer);
  }, [onSplashScreenClose]);

  useEffect(() => {
    if (!jwt && !isSplashScreenOpen && !isUnsubscribe) {
      onOpen();
    }
  }, [onOpen, isSplashScreenOpen, isUnsubscribe]);

  return (
    <>
      <Modal
        isOpen={isSplashScreenOpen}
        motionPreset="none"
        onClose={onSplashScreenClose}
        size="full"
      >
        <ModalOverlay />
        <ModalContent background="#292935" margin="0">
          <ModalBody alignItems="center" display="flex" justifyContent="center">
            <img alt="" src={bingOlyImg} />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpen && !isSplashScreenOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display="flex" justifyContent="center" mt="-20px">
            <img alt="" src={bingOlyImg} />
          </ModalHeader>
          <ModalBody mb="-80px">
            <Text color="#101011" fontSize="14px" mb="-70px" mt="12px">
              {t(tKeys.winPrizes)}
            </Text>
            <Image
              alt=""
              mt={isMobile ? undefined : '-120px'}
              src={welcomeImg}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              color="#073C1C"
              mt={isMobile ? undefined : '-26px'}
              onClick={onClose}
              variant="primary"
              width="100%"
            >
              {t(tKeys.letsGo)}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
